import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const HeartFailure = lazy(() => import('../pages/heart-failure/page'));
const EarlyDetection = lazy(() => import('../pages/early-detection/page'));
const RegionalCooperation = lazy(() => import('../pages/regional-cooperation/page'));
const ReferralHospitals = lazy(() => import('../pages/referral-hospitals/page'));
const News = lazy(() => import('../pages/news/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Examination = lazy(() => import('../pages/examination/page'));
const Column = lazy(() => import('../pages/column/page'));
const Research = lazy(() => import('../pages/research/page'));
const Publications = lazy(() => import('../pages/publications/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/heart-failure',
    element: <HeartFailure />,
  },
  {
    path: '/early-detection',
    element: <EarlyDetection />,
  },
  {
    path: '/regional-cooperation',
    element: <RegionalCooperation />,
  },
  {
    path: '/referral-hospitals',
    element: <ReferralHospitals />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/examination',
    element: <Examination />,
  },
  {
    path: '/column',
    element: <Column />,
  },
  {
    path: '/research',
    element: <Research />,
  },
  {
    path: '/publications',
    element: <Publications />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
